AFRAME.registerComponent("cursor-controller", {
    dependencies: ["system", "a-node", "raycastervr"],
    schema: {
        cursor: {
            type: "selector",
        },
        camera: {
            type: "selector",
        },
        maxDistance: {
            default: 5,
        },
        minDistance: {
            default: 0.05,
        },
        cursorColorHovered: {
            default: "#00A7FA",
        },
        cursorColorUnhovered: {
            default: "#FFFFFF",
        },
        rayObject: {
            type: "selector",
        },
        useMousePos: {
            default: false,
        },
        drawLine: {
            default: false,
        },
        usePointerLock: {
            default: true,
        },
        useLook: {
            default: true,
        },
        useZoom: {
            default: true,
        },
    },
    init: function () {
        this.enabled = true;
        this.inVR = false;
        this.isMobile = AFRAME.utils.device.isMobile();
        this.currentTargetType = 1;
        this.currentDistance = this.data.maxDistance;
        this.usePointerLock = this.data.usePointerLock;
        this.useLook = this.data.useLook;
        this.useZoom = this.data.useZoom;
        this.currentDistanceMod = 0;
        this.mousePos = new THREE.Vector2();
        this.wasCursorHovered = false;
        this.origin = new THREE.Vector3();
        this.direction = new THREE.Vector3();
        this.raycasterAttr = this.el.getAttribute("raycastervr");
        this.controllerQuaternion = new THREE.Quaternion();
        this.data.cursor.setAttribute("material", {
            color: this.data.cursorColorUnhovered,
        });
        this.raycaster = this.el.components.raycastervr.raycaster;
        this.handleCursorLoaded = this.handleCursorLoaded.bind(this);
        this.data.cursor.addEventListener("loaded", this.handleCursorLoaded);
        const geometry = new THREE.BufferGeometry();
        geometry.setAttribute(
            "position",
            new THREE.BufferAttribute(new Float32Array(6), 3)
        );
        this.line = new THREE.Line(
            geometry,
            new THREE.LineBasicMaterial({
                color: "white",
                opacity: 0.7,
                transparent: true,
                visible: false,
                linewidth: 5,
            })
        );
        this.el.setObject3D("line", this.line);
    },
    update: function (oldData) {
        this.usePointerLock = this.data.usePointerLock;
    },
    enable: function () {
        this.enabled = true;
    },
    disable: function () {
        this.enabled = false;
    },
    updateRay: function () {
        this.raycasterAttr.origin = this.origin;
        this.raycasterAttr.direction = this.direction;
        this.raycaster.far = this.raycasterAttr.far;
        this.raycaster.near = this.raycasterAttr.near;
    },
    tick: ((tempQuaternion, tempVector3) => {
        return function () {
            if (this.enabled) {
                if (this.data.useMousePos) {
                    this.setRaycasterWithMousePos();
                } else if (this.data.rayObject) {
                    const object = this.data.rayObject.object3D;
                    tempQuaternion.setFromRotationMatrix(object.matrixWorld);
                    this.direction
                        .set(0, 0, -1)
                        .applyQuaternion(tempQuaternion)
                        .normalize();
                    this.origin.setFromMatrixPosition(object.matrixWorld);
                    this.updateRay();
                }
                if (this.isInteracting()) {
                    const distance = Math.min(
                        this.data.maxDistance,
                        Math.max(
                            this.data.minDistance,
                            this.currentDistance - this.currentDistanceMod
                        )
                    );
                    this.data.cursor.object3D.position.copy(
                        this.raycasterAttr.origin
                    );
                    this.data.cursor.object3D.position.addScaledVector(
                        this.raycasterAttr.direction,
                        distance
                    );
                } else {
                    this.currentDistanceMod = 0;
                    this.updateDistanceAndTargetType();
                    const isHovered = this.isTargetOfType(6);
                    if (isHovered && !this.wasCursorHovered) {
                        this.wasCursorHovered = true;
                        this.data.cursor.setAttribute("material", {
                            color: this.data.cursorColorHovered,
                        });
                    } else if (!isHovered && this.wasCursorHovered) {
                        this.wasCursorHovered = false;
                        this.data.cursor.setAttribute("material", {
                            color: this.data.cursorColorUnhovered,
                        });
                    }
                }
                if (this.data.drawLine) {
                    const start = this.origin.clone();
                    const end = this.data.cursor.object3D.position.clone();
                    const positions =
                        this.line.geometry.attributes.position.array;
                    positions[0] = start.x;
                    positions[1] = start.y;
                    positions[2] = start.z;
                    positions[3] = end.x;
                    positions[4] = end.y;
                    positions[5] = end.z;
                    this.line.geometry.attributes.position.needsUpdate = true;
                    this.line.geometry.computeBoundingSphere();
                    this.line.material.visible = true;
                } else {
                    this.line.material.visible = false;
                }
            }
        };
    })(),
    setRaycasterWithMousePos: function () {
        const camera = this.data.camera.components.camera.camera;
        this.raycaster.firstHitOnly = true;
        this.raycaster.setFromCamera(this.mousePos, camera);
        this.origin.copy(this.raycaster.ray.origin);
        this.direction.copy(this.raycaster.ray.direction);
        this.updateRay();
    },
    updateDistanceAndTargetType: function () {
        let intersection = null;
        const intersections = this.el.components.raycastervr.intersections;
        if (intersections.length > 0) {
            intersection = intersections[0];
            this.data.cursor.object3D.position.copy(intersection.point);
            this.currentDistance = intersection.distance;
        } else {
            this.currentDistance = this.data.maxDistance;
            this.direction.multiplyScalar(this.currentDistance);
            this.data.cursor.object3D.position.addVectors(
                this.origin,
                this.direction
            );
        }
        if (intersection) {
            if (
                intersection.object.el.matches(".interactable, .interactable *")
            ) {
                this.currentTargetType = 2;
            } else if (intersection.object.el.matches(".ui, .ui *")) {
                this.currentTargetType = 4;
            }
        } else {
            this.currentTargetType = 1;
        }
    },
    isTargetOfType: function (type) {
        return (this.currentTargetType & type) === this.currentTargetType;
    },
    setCursorVisibility: function (visible) {
        this.data.cursor.setAttribute("visible", visible);
    },
    forceCursorUpdate: function () {
        this.setRaycasterWithMousePos();
        this.el.components.raycastervr.checkIntersections();
        this.updateDistanceAndTargetType();
    },
    isInteracting: function () {
        return this.data.cursor.components["super-hands"].state.has(
            "grab-start"
        );
    },
    startInteraction: function (mouseTarget) {
        if (this.isTargetOfType(6)) {
            this.data.cursor.emit("cursor-grab", {
                mouseTarget: mouseTarget,
            });
            return true;
        }
        return false;
    },
    moveCursor: function (x, y) {
        this.mousePos.set(x, y);
    },
    endInteraction: function () {
        this.data.cursor.emit("cursor-release", {});
    },
    changeDistanceMod: function (delta) {
        if (this.useZoom) {
            let zoom = this.data.camera.getAttribute("camera").zoom - delta;
            zoom = Math.min(Math.max(zoom, 1), 8);
            this.data.camera.setAttribute("camera", "zoom", zoom);
        }
    },
    handleCursorLoaded: function () {
        this.data.cursor.removeEventListener("loaded", this.handleCursorLoaded);
    },
    remove: function () {
        this.data.cursor.removeEventListener("loaded", this.handleCursorLoaded);
    },
});
